export default "__VITE_PUBLIC_ASSET__6e65961c__"